var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs2, _path34, _defs3, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.8 277.8",
    style: {
      enableBackground: "new 0 0 290.8 277.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000120552326653541960080000006387034228452397497_);}\n\t.st1{fill:#A4603F;}\n\t.st2{fill:#009365;}\n\t.st3{fill:#8FB2DA;}\n\t.st4{fill:#604674;}\n\t.st5{fill:#4D2D5C;}\n\t.st6{fill:#382626;}\n\t.st7{fill:#884726;}\n\t.st8{fill:#622E1B;}\n\t.st9{fill:#78371F;}\n\t.st10{clip-path:url(#SVGID_00000142893050141987812520000002866322288445088923_);}\n\t.st11{fill:#E4D4C0;}\n\t.st12{clip-path:url(#SVGID_00000020389226873674250840000015947285925578341522_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5453",
    transform: "translate(0 23.5) rotate(-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5422",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    transform: "matrix(0.9962 -8.715574e-02 8.715574e-02 0.9962 -10.6098 12.2355)",
    width: 269.6,
    height: 255.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016776660569661521090000017152147386462454455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5421",
    style: {
      clipPath: "url(#SVGID_00000016776660569661521090000017152147386462454455_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22298",
    className: "st1",
    d: "M36.2,141.7L36.2,141.7c2.5,5.8,9.3,8.4,15,5.9l61.5-19.5c6.6-2.9,9.7-10.7,6.7-17.4 s-10.7-9.7-17.4-6.7c-0.2,0.1-0.3,0.1-0.5,0.2l-59.5,22.4C36.4,129.2,33.7,135.9,36.2,141.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22299",
    className: "st2",
    d: "M248.1,255.2l13.4-92.7l-42.2-43.8L161.5,167L248.1,255.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22300",
    className: "st3",
    d: "M158.5,170.7c0,0,12.5,1,42.1-23.7c20.9-17.5,23.8-28.1,23.8-28.1l-26.8-57.3 c-6.4-13.1-18.2-17.2-30.3-9.2L117.6,85c-11.7,7.7-13.3,19.8-4.8,30.9L158.5,170.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22301",
    className: "st4",
    d: "M154.6,86.8c6.3-5.3,7.6-14.5,3.1-21.3c-0.1-0.2-0.3-0.2-0.5-0.1 c-0.2,0.1-0.2,0.3-0.1,0.5c0,0,0,0,0,0c4.7,7.1,2.8,16.7-4.3,21.4c-7.1,4.7-16.7,2.8-21.4-4.3c0,0,0,0,0,0 c-0.1-0.2-0.3-0.2-0.5-0.1c-0.2,0.1-0.2,0.3-0.1,0.5c4.9,7.4,14.9,9.4,22.3,4.4C153.6,87.6,154.1,87.2,154.6,86.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22302",
    className: "st5",
    d: "M236.8,139.3c0.5-0.4,0.9-0.8,1.3-1.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0 c-0.1,0.1-5.6,5.9-12.9,6c-4.2,0.1-8.2-1.8-11.8-5.5c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.1,0.3,0,0.4c3.8,3.8,7.9,5.7,12.3,5.7 C230.2,144.2,234.7,141.1,236.8,139.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22303",
    className: "st5",
    d: "M207.7,164.4c0.1-0.1,0.1-0.2,0.1-0.4l-6.3-10.2c-0.2-0.3-0.7-0.4-1-0.2c0,0,0,0,0,0 l-5.3,3.8c-0.3,0.2-0.4,0.7-0.2,1c0,0,0.1,0.1,0.1,0.1l4.3,4.1c0.1,0.1,0.3,0.1,0.4-0.1c0.1-0.1,0.1-0.3,0-0.4l-4.3-4.1 c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l5.3-3.8c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1l6.3,10.2 C207.3,164.5,207.5,164.5,207.7,164.4L207.7,164.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22304",
    className: "st5",
    d: "M176.1,181.2L176.1,181.2c6.8-7.9,0.7-17.9,0.7-18c-0.1-0.1-0.2-0.2-0.4-0.1 s-0.2,0.2-0.1,0.4c0,0,0,0,0,0c0.1,0.1,5.9,9.8-0.6,17.3c-0.1,0.1-0.1,0.3,0,0.4C175.8,181.3,176,181.3,176.1,181.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22305",
    className: "st3",
    d: "M103.4,135.7l-17-28l16.2-9.9c14.2-8.6,32.6-4.1,41.3,10.1c0,0,0,0,0,0 c0.8,1.3,0.4,3-0.9,3.8c0,0,0,0,0,0L103.4,135.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22306",
    className: "st4",
    d: "M93.8,113.1c0.1,0.1,0.3,0.1,0.4-0.1c0.1-0.1,0.1-0.2,0-0.4l-4-6.5 c-0.1-0.2-0.3-0.2-0.4-0.1s-0.2,0.3-0.1,0.4c0,0,0,0,0,0L93.8,113.1C93.8,113.1,93.8,113.1,93.8,113.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22307",
    className: "st4",
    d: "M139.6,148.5c0.1-0.1,0.2-0.3,0-0.4c0,0,0,0,0,0l-18-21.6c-0.1-0.1-0.3-0.1-0.4,0 c-0.1,0.1-0.1,0.3,0,0.4l18,21.6C139.3,148.6,139.5,148.6,139.6,148.5C139.6,148.5,139.6,148.5,139.6,148.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22308",
    className: "st1",
    d: "M14.1,69.4L14.1,69.4c-3.7,1.6-5.2,6.4-3.5,10.9l21.5,58.2c3.1,6.9,10.2,10.3,16,7.7 s7.9-10.2,4.8-17.1L24.5,73.8C22.2,69.7,17.7,67.7,14.1,69.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22309",
    className: "st1",
    d: "M24.2,78.3c0.3-1.7,0.5-3.4,0.6-5.1c0.1-1.7,0-3.3-0.1-5c-0.2-1.7-0.5-3.3-1-4.9 c-0.5-1.6-1.3-3.1-2.3-4.5c-0.3-0.4-0.9-0.5-1.2-0.2c-0.3,0.2-0.4,0.6-0.3,1l0,0.1c0.9,2.7,1,5.6,0.3,8.3 c-0.3,1.4-0.7,2.8-1.2,4.1c-0.5,1.3-1,2.6-1.7,3.8c-1,1.8-0.4,4.1,1.4,5.1c1.8,1,4.1,0.4,5.1-1.4c0.2-0.3,0.3-0.7,0.4-1.1 L24.2,78.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22310",
    className: "st1",
    d: "M15.8,77.9c-0.1-1.8-0.4-3.9-0.6-5.8c-0.3-1.9-0.6-3.9-1-5.8c-0.7-3.8-1.9-7.6-3.6-11.1 l0,0c-0.3-0.6,0-1.3,0.6-1.6c0.5-0.2,1.1-0.1,1.5,0.3c2.5,3.4,4.6,7,6.2,10.9c0.8,1.9,1.6,3.8,2.3,5.8c0.7,2,1.4,3.9,1.9,6 c0.7,1.9-0.4,4-2.3,4.7c-1.9,0.7-4-0.4-4.7-2.3c0-0.1-0.1-0.3-0.1-0.4C15.9,78.4,15.8,78.2,15.8,77.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22311",
    className: "st1",
    d: "M14.9,86.1c-1-1.4-2.2-2.9-3.3-4.4c-1.1-1.4-2.3-2.9-3.5-4.3c-2.4-2.8-4.9-5.5-7.6-8 l0,0c-0.5-0.4-0.5-1.2-0.1-1.7c0.4-0.4,1-0.5,1.5-0.2c3.3,1.9,6.5,4.1,9.5,6.4c1.5,1.1,3,2.3,4.5,3.5c1.5,1.2,2.9,2.4,4.4,3.7 c1.6,1.3,1.8,3.6,0.5,5.2c-1.3,1.6-3.6,1.8-5.2,0.5c-0.1-0.1-0.1-0.1-0.2-0.2C15.2,86.5,15,86.3,14.9,86.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22312",
    className: "st1",
    d: "M10.9,77.1c-0.6-1.2-1.2-2.4-1.9-3.5c-0.7-1.2-1.5-2.3-2.3-3.4 c-1.6-2.2-3.5-4.3-5.5-6.1l0,0c-0.5-0.4-0.6-1.2-0.1-1.7C1.4,61.9,2,61.8,2.4,62c2.8,1.3,5.4,2.8,7.7,4.7 c1.2,0.9,2.4,1.9,3.5,2.9c1.2,1.1,2.3,2.2,3.3,3.4l0.1,0.1c1.4,1.6,1.2,3.9-0.4,5.3c-1.6,1.4-3.9,1.2-5.3-0.4 C11.2,77.7,11,77.4,10.9,77.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22313",
    className: "st1",
    d: "M14.5,75c-0.7-1.5-1.5-3-2.3-4.5c-0.8-1.5-1.6-3-2.5-4.5c-0.9-1.5-1.8-2.9-2.7-4.3 C6.1,60.4,5,59,3.9,57.8l0,0c-0.5-0.5-0.4-1.2,0-1.7c0.4-0.4,1-0.4,1.5-0.2c1.5,1,3,2.1,4.3,3.4c1.3,1.2,2.6,2.5,3.9,3.7 c1.2,1.3,2.5,2.6,3.6,3.9c1.2,1.3,2.3,2.6,3.5,4.1l0,0c1.3,1.6,1.1,3.9-0.5,5.2s-3.9,1.1-5.2-0.5l0,0 C14.8,75.6,14.7,75.3,14.5,75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22314",
    className: "st1",
    d: "M264.6,82.2L264.6,82.2c-1.6,6.1-7.9,9.7-14,8.1l-68.5-10.4c-7-1.9-11.2-9.1-9.4-16.1 s9.1-11.2,16.1-9.4c0.2,0.1,0.4,0.1,0.6,0.2l67,13.6C262.6,69.9,266.2,76.1,264.6,82.2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22315",
    className: "st3",
    d: "M206.8,89.1l8.4-31.7l-22.7-6c-13.6-3.6-27.7,4.5-31.3,18.1c-1,3.9,1.3,7.8,5.1,8.8 L206.8,89.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22316",
    className: "st4",
    d: "M201.8,87.8c0,0,0.1-0.1,0.1-0.2l8.2-29.9c0-0.2-0.1-0.3-0.2-0.4 c-0.2,0-0.3,0.1-0.4,0.2l-8.2,29.9c0,0.2,0.1,0.3,0.2,0.4C201.6,87.9,201.7,87.9,201.8,87.8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22317",
    className: "st4",
    d: "M207,89.3l3.8-12.8c0-0.2,0-0.3-0.2-0.4c-0.2,0-0.3,0-0.4,0.2l-3.6,12.2l-13.9-3.7 c-0.2,0-0.3,0.1-0.4,0.2c0,0.2,0.1,0.3,0.2,0.4L207,89.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22318",
    className: "st1",
    d: "M255.9,0L255.9,0c-4,0.4-7,4.4-6.8,9.1l-2.3,68.3c0.7,7.5,6.3,13.1,12.6,12.5 c6.3-0.6,10.8-7.1,10.1-14.6l-5.3-67.7C263.5,3,259.8-0.3,255.9,0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22319",
    className: "st1",
    d: "M262.5,72.2c-4-4.7-11-5.4-15.7-1.4s-5.4,11-1.4,15.7c4,4.7,11,5.4,15.7,1.4 C265.8,83.9,266.4,76.9,262.5,72.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22320",
    className: "st6",
    d: "M97.2,45c0,0-3.6-10.1-0.7-14.9s8.2,3.5,8.2,3.5L97.2,45z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22321",
    className: "st1",
    d: "M151.5,85.2c3.4-2.4,6.1-13.1,2.3-18.7l-13.3-20.1c-3.8-5.7-11.4-7.2-17.1-3.5 c-5.7,3.8-7.2,11.4-3.5,17.1l13.3,20.1C137.1,85.8,148.1,87.6,151.5,85.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22322",
    className: "st7",
    d: "M139.9,45.6l-6.3-9.8c-3.6-5.6-11.1-7.3-16.7-3.7c0,0,0,0,0,0 c-5.6,3.6-7.8,11.7-4.2,17.3l20.1,29.8l7.2-33.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22323",
    className: "st1",
    d: "M128.1,71.6L128.1,71.6c10.5-4,15.8-15.7,11.9-26.2c0,0,0,0,0,0l-5.2-14.1 c-3.9-10.7-15.3-15.5-25.4-10.8s-15.1,17.3-11.2,28l3.9,10.8C105.9,69.8,117.5,75.3,128.1,71.6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22324",
    className: "st6",
    d: "M95.5,35.2c0,0,20.6-10.6,28-7.5c3,1.2,9.8,12.7,9.8,12.7l4.2-2.9 c0,0-4.6-12.9-6.4-15.6c-2.2-3.2-9-7.2-19.9-3C93.7,25.6,95.5,35.2,95.5,35.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22325",
    className: "st8",
    d: "M122.4,60.1c0.2-0.6-0.1-1.2-0.7-1.4c-0.3-0.1-0.7-0.1-0.9,0.1c-1.6,1.1-3.4,2-5.2,2.7 c-1.8,0.7-3.6,1.2-5.5,1.5c-0.4,0.1-0.7,0.4-0.7,0.9c0,0.2,0.1,0.4,0.3,0.5c1.7,1.2,4.6,2.7,7.8,1.5 C120.2,64.8,121.6,62.2,122.4,60.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22326",
    className: "st6",
    d: "M102.9,52c0.3,0.8,1.2,1.3,2,1.1c0.8-0.3,1.3-1.2,1.1-2c-0.3-0.8-1.2-1.3-2-1.1 c0,0,0,0,0,0C103.1,50.3,102.7,51.2,102.9,52"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22327",
    className: "st6",
    d: "M117.4,46.8c0.3,0.8,1.2,1.3,2,1.1s1.3-1.2,1.1-2c-0.3-0.8-1.2-1.3-2-1.1c0,0,0,0,0,0 C117.6,45.1,117.2,46,117.4,46.8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22328",
    className: "st9",
    d: "M112.4,58.3c-0.7,0-1.5-0.2-2-0.7c-1.2-0.9-1.6-2.4-1.1-3.7c0.1-0.3,0.4-0.5,0.7-0.4 c0.3,0.1,0.5,0.4,0.4,0.7c-0.3,0.9-0.1,1.9,0.7,2.4c0.7,0.6,1.7,0.6,2.5,0.1c0.3-0.2,0.6-0.1,0.8,0.2c0.2,0.3,0.1,0.6-0.1,0.8 C113.6,58.1,113,58.3,112.4,58.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22329",
    className: "st6",
    d: "M121.5,44c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.1-1.7-2.2-5-1.1c-0.3,0.1-0.7-0.1-0.8-0.4 c0,0,0,0,0,0c-0.1-0.3,0.1-0.7,0.4-0.8c0,0,0,0,0,0c4.2-1.3,6.4,1.5,6.4,1.6c0.2,0.3,0.2,0.7-0.1,0.9 C121.8,44,121.6,44,121.5,44"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22330",
    className: "st6",
    d: "M107.6,49.1c-0.2,0-0.3-0.1-0.5-0.2c-1.4-1.2-3.5-1.4-5.1-0.4c-0.3,0.2-0.7,0-0.9-0.3 c-0.2-0.3,0-0.7,0.3-0.9c0,0,0,0,0,0c2.1-1.2,4.8-0.9,6.6,0.7c0.2,0.3,0.2,0.7,0,0.9C107.9,49,107.8,49.1,107.6,49.1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5424",
    transform: "translate(109.397 58.683)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149355340662860173380000011986914178312717994_",
    d: "M11.4,0.2C9.7,1.3,8,2.2,6.2,2.9 C4.4,3.6,2.6,4.1,0.7,4.4C0.2,4.4-0.1,4.8,0,5.2c0,0.2,0.1,0.4,0.3,0.5C2,6.9,4.9,8.5,8.1,7.2c2.8-1.1,4.2-3.7,4.9-5.8 c0.2-0.6-0.1-1.2-0.7-1.4C12.2,0,12.1,0,12,0C11.7,0,11.5,0.1,11.4,0.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035523262719679739410000014332662264166952587_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149355340662860173380000011986914178312717994_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5423",
    style: {
      clipPath: "url(#SVGID_00000035523262719679739410000014332662264166952587_)"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22331",
    className: "st11",
    d: "M0.4,3.4c0.6,1.6,3.5,2.1,6.4,1s4.8-3.3,4.1-4.9c-0.6-1.6-3.5-2.1-6.4-1 S-0.2,1.8,0.4,3.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5426",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000045617728267165793490000014216167323561085615_",
    x: 0,
    y: 0,
    transform: "matrix(0.9962 -8.715574e-02 8.715574e-02 0.9962 -10.6098 12.2355)",
    width: 269.6,
    height: 255.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177479858355526427650000015267648043513412497_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045617728267165793490000014216167323561085615_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5425",
    style: {
      clipPath: "url(#SVGID_00000177479858355526427650000015267648043513412497_)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22333",
    className: "st9",
    d: "M118.8,69.8c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.3,0.1-0.4c0.3-0.2,0.4-0.6,0.2-0.8 c-0.2-0.3-0.6-0.4-0.8-0.2c-0.3,0.2-0.4,0.6-0.2,0.8c0,0,0,0,0,0c0.1,0.1,0.1,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4-0.1 c-0.4-0.5-0.2-1.3,0.3-1.7c0.5-0.4,1.3-0.2,1.7,0.3c0.4,0.5,0.2,1.3-0.3,1.7c0,0,0,0,0,0C119,69.8,118.9,69.8,118.8,69.8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22334",
    className: "st11",
    d: "M113.8,58.9c-0.2,0-0.4,0-0.6-0.1c-0.1,0-0.2-0.2-0.1-0.3c0,0,0,0,0,0 c0-0.1,0.2-0.2,0.3-0.1c0,0,0,0,0,0c0.6,0.3,1.3,0,1.6-0.6c0.2-0.4,0.1-0.8-0.1-1.1c-0.2-0.3-0.4-0.4-0.8-0.5 c-0.3-0.1-0.6,0-0.9,0.2c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0.7-0.5,1.7-0.3,2.3,0.4 c0.5,0.7,0.3,1.7-0.4,2.3C114.4,58.8,114.1,58.9,113.8,58.9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22335",
    className: "st1",
    d: "M129,46.8c2.2,3.4,6.7,4.3,10.1,2.1c3.4-2.2,4.3-6.7,2.1-10.1 c-2.2-3.4-6.7-4.3-10.1-2.2C127.8,38.9,126.8,43.4,129,46.8C129,46.8,129,46.8,129,46.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22336",
    className: "st9",
    d: "M134,43.8c-0.7-1.5,0-3.2,1.4-3.8c0.3-0.1,0.6-0.2,0.9-0.2c0.6-0.1,0.8,0.9,0.2,0.9 c-1.1,0-1.9,0.9-1.9,2c0,0.2,0.1,0.5,0.2,0.7C135.1,44,134.2,44.4,134,43.8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22337",
    className: "st9",
    d: "M134,43.5c0.4-1,1.5-1.7,2.6-1.6c0.6,0,0.5,1-0.1,1c-0.7,0-1.3,0.3-1.6,1 C134.7,44.4,133.8,44.1,134,43.5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration1);
export default __webpack_public_path__ + "static/media/illustration_1.916814a150037834b45649786e9e60d9.svg";
export { ForwardRef as ReactComponent };